import { Component, Vue, Prop } from 'vue-property-decorator';

import Chevron from '@/assets/icons/chevron.svg?inline';
import vSelect from 'vue-select';
import { BrochureItem, BrochureUpdateCount } from '../BrochureRequestModule.types';
import ButtonRow from '@/forms/FormElements/Rows/ButtonRow/ButtonRow.vue';

@Component({
  components: {
    Chevron,
    vSelect,
    ButtonRow,
  },
})
export default class OrderSummaryLockup extends Vue {
  @Prop({ type: Array as () => BrochureItem[], default: () => [] })
  readonly SelectedBrochures!: BrochureItem[];

  @Prop(Boolean)
  readonly IsBtB!: boolean;

  get totalQuantity() {
    return this.SelectedBrochures.reduce(
      (acc: number, current: BrochureItem) => acc + (current.Count || 1),
      0,
    );
  }

  get brochureQuantityList() {
    return Array.from({ length: 10 }, (_, i) => 1 + i);
  }

  submitBrochures() {
    this.$emit('submitBrochures');
  }

  updateBrochureCount(value, Id) {
    const obj: BrochureUpdateCount = {
      Id: Id,
      Count: value,
    };
    this.$emit('updateBrochureCount', obj);
  }

  convertToString = (count: number) => count.toString();

  mounted() {
    window.scrollTo(0,0);
  }
}
